import { SearchState } from './search.state';
import { SearchActionsUnion, SearchActionTypes } from './search.actions';
import { NUMBER_1 } from '~shared/constants';

export const searchInitialState: SearchState = {
  searchQuery: '',
  isSearchInputFocused: false,
  isSearchFromHeaderBar: false,
  navigatedToSearch: false,
  pageNumberWhenUserSearchedFromHeaderBar: NUMBER_1,
};

export function searchReducer(
  state = searchInitialState,
  action: SearchActionsUnion,
): SearchState {

  switch (action.type) {

    case SearchActionTypes.FOCUS_ON_SEARCH:
      return {
        ...state,
        isSearchInputFocused: action.payload
      };

    case SearchActionTypes.UPDATE_SEARCH_QUERY:
      return {
        ...state,

        searchQuery: action.payload
      };
    case SearchActionTypes.SEARCH_FROM_HEADER_BAR:
      return {
        ...state,
        isSearchFromHeaderBar: action.payload.isSearchFromHeaderBar,
        pageNumberWhenUserSearchedFromHeaderBar: action.payload.pageNumberWhenUserSearchedFromHeaderBar,
      };

    case SearchActionTypes.NAVIGATE_SEARCH_ROUTE:
      return {
        ...state,
        navigatedToSearch: true
      };
    case SearchActionTypes.RESET_NAVIGATE_SEARCH_ROUTE:
      return {
        ...state,
        navigatedToSearch: false
      };
    default:
      return state;
  }
}
